export const LIQUID_NATIVE_TOKEN_LABEL = "HBARX";
export const NATIVE_TOKEN_LABEL = "HBAR";

export const tvlCap = {};

// How do I provide dynamic tooltips
export const tooltips = {};

export const urls = {
  faq: "https://docs.staderlabs.com/stader-hbar-staking/faqs",
  termsOfService: "https://staderlabs.com/terms-of-service",
};

export const transactionsTypeMap = {};

export const transactionsStatusMap = {};

export const NATIVE_TOKEN_MULTIPLIER = 100000000;

export const tvlPrecision = 0;
export const emissionRate = 399999.9992 * NATIVE_TOKEN_MULTIPLIER; //Per day
export const unBondingTime = 24 * 60 * 60; //24 * 60 * 60; // 24 hours
export const usdTransactionFee = 0.2; // USD
export const version = 1.0;
export const apiPath = "api/v1/";
export const tokenLabel = LIQUID_NATIVE_TOKEN_LABEL;
export const precision = 4; //0.0001
export const fiatPrecision = 2; // 0.01
export const transactionFees = 1; //1 hbar
export const NATIVE_TOKEN_INPUT_MAXIMUM_DECIMAL_POINTS = precision;
export const NATIVE_TOKEN_INPUT_MAXIMUM_INTEGER_POINTS = 9;
export const decimal = 8;

export const gtmId = "GTM-KCLNW9N";
export const tvlUpdateInterval = 10 * 1000;
export const ratesAPI =
  "https://api.coingecko.com/api/v3/simple/price?ids=hedera-hashgraph&vs_currencies=usd";

export const TWITTER_URL = "https://twitter.com/stader_hbar";
export const TELEGRAM_URL = "https://t.me/StaderLabs_Hedera_Official";

export const DESKTOP_VIEW_PX = 1200;

export const getEmissionRate = (emissionRate: number) =>
  emissionRate * NATIVE_TOKEN_MULTIPLIER;
export const FIREBASE_EVENT_PROPERTIES = {
  EVENT_NAME: "event_name",
  WALLET_CTA: "wallet_cta",
  WALLET_NAME: "wallet_name",
  WALLET_ADDRESS: "wallet_address",
  TOKEN_BALANCE: "token_balance",
  LIQUIDTOKEN_BALANCE: "liquidtoken_balance",
  STAKE_AMOUNT_ENTERED: "stake_amount_entered",
  UNSTAKE_AMOUNT_ENTERED: "stake_amount_entered",
  HASH: "hash",
  TOTAL_TOKEN_STAKED: "total_token_staked",
  TOKEN_STAKED_NOW: "token_staked_now",
  TOKEN_UNSTAKED_NOW: "token_unstaked_now",
  WITHDRAW_AMOUNT: "withdraw_amount",
  DEFI: "defi_cta",
  DEFI_NAME: "defi_name",
  AUDIT_TYPE: "audit_type",
  LOCATION: "location",
  JOC_TYPE: "joc_type",
  NEXT_BLOCKCHAIN: "Next_blockchain",
  EMAIL: "email",
  NETWORK_SWITCHED_TO: "network_switched_to",
  ACCEPT_TOS_CHECKBOX: "Accpet_TOS_Checkbox",
  READ_TERMS_OF_SERVICES: "Read_Terms_of_services ",
};
